export function parseDateOnly(value: string): Date {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, (month ?? 1) - 1, day ?? 1);
}

export function formatDateOnly(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDateOnlyLabel(value?: string | null): string | null {
  if (!value) return null;
  const date = parseDateOnly(value.slice(0, 10));
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", year: "numeric" });
}

/** Inclusive list of Y-m-d strings from either bound to the other. */
export function enumerateDateRange(start: string, end: string): string[] {
  const a = parseDateOnly(start);
  const b = parseDateOnly(end);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return [];
  const from = a <= b ? a : b;
  const to = a <= b ? b : a;
  const days: string[] = [];
  const cursor = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  while (cursor <= to) {
    days.push(formatDateOnly(cursor));
    cursor.setDate(cursor.getDate() + 1);
  }
  return days;
}
